import { Edit3, GraduationCap, Megaphone, Calendar, Link2 } from "lucide-react";
import { CATEGORIES } from "../../data/serviceRequestCategories";
import { Field, DynamicField } from "./formFields";

const iconMap = { Edit3, GraduationCap, Megaphone, Calendar, Link2 };

export default function CategoryStep({ data, update, toggleSubtype }) {
  const selectedCategory = CATEGORIES.find((c) => c.id === data.categoryId);

  const selectCategory = (cat) => {
    update("categoryId", cat.id);
    update("categoryName", cat.name);
    update("subtypes", []);
    update("categoryFields", {});
  };

  const setCategoryField = (label, value) => {
    update("categoryFields", { ...data.categoryFields, [label]: value });
  };

  return (
    <div data-testid="request-category-step">
      <h2 className="text-xl font-semibold text-gray-900 mb-1" style={{ fontFamily: "Outfit, sans-serif" }}>
        What kind of request is this?
      </h2>
      <p className="text-sm text-gray-500 mb-6">{"Choose the closest fit \u2014 the form below will adjust to ask the right questions."}</p>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-6">
        {CATEGORIES.map((cat) => {
          const Icon = iconMap[cat.icon];
          const active = data.categoryId === cat.id;
          return (
            <button
              key={cat.id}
              type="button"
              onClick={() => selectCategory(cat)}
              data-testid={`request-category-card-${cat.id}`}
              className="text-left rounded-2xl border-2 p-4 transition-all"
              style={{
                borderColor: active ? "#194449" : "#E2EBE9",
                backgroundColor: active ? "#194449" : "#fff",
              }}
            >
              <Icon size={20} className="mb-2" style={{ color: active ? "#D4EC8E" : "#194449" }} />
              <div className="text-sm font-semibold leading-tight mb-1" style={{ color: active ? "#fff" : "#111827" }}>{cat.name}</div>
              <div className="text-xs leading-snug" style={{ color: active ? "#CFE0DC" : "#8B9694" }}>{cat.desc}</div>
            </button>
          );
        })}
      </div>

      {selectedCategory && (
        <div className="rounded-2xl p-6" style={{ backgroundColor: "#F8FFFE", borderLeft: "3px solid #C4D82E" }} data-testid="request-dynamic-panel">
          <p className="font-semibold text-sm mb-3" style={{ color: "#194449" }}>{`${selectedCategory.name} \u2014 Details`}</p>

          <div className="mb-5">
            <label className="block text-sm font-semibold text-gray-800 mb-2">
              Which of these apply? <span className="text-xs text-gray-400 font-normal">(select all relevant)</span>
            </label>
            <div className="flex flex-wrap gap-2">
              {selectedCategory.subtypes.map((s) => {
                const active = data.subtypes.includes(s);
                return (
                  <button
                    key={s}
                    type="button"
                    onClick={() => toggleSubtype(s)}
                    data-testid={`request-chip-${s.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
                    className="rounded-full px-3.5 py-1.5 text-xs font-medium border transition-all"
                    style={{
                      borderColor: active ? "#1D5C56" : "#DCE3E1",
                      backgroundColor: active ? "#1D5C56" : "#fff",
                      color: active ? "#fff" : "#1A1A1A",
                    }}
                  >
                    {s}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6">
            {selectedCategory.fields.map((f) => (
              <Field key={f.id} label={f.label} testId={`request-field-${f.id}`}>
                <DynamicField
                  field={f}
                  value={data.categoryFields[f.label]}
                  onChange={(v) => setCategoryField(f.label, v)}
                />
              </Field>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
